var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cardcustom"},[_c('div',{staticClass:"titledashboard"},[_c('div',[_vm._t("titledsahboard")],2),_c('div',[_vm._t("sortingdashboard")],2)]),_vm._t("table")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }